export const Approved = ({ size = 11 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 11 11"
  >
    <path
      stroke="#5AB365"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.475 5.5 1.35 1.35 2.7-2.7M10 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
    />
  </svg>
);
